import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconGearSharpFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <g clipPath="url(#icon-gear-sharp-fill__a)">
      <path
        stroke="currentColor"
        d="M18.028 12.792c.034-.261.051-.525.05-.788a4.887 4.887 0 0 0-.058-.789c.451-.35 1.857-1.573 1.857-1.573l-1.873-3.274s-1.778.598-2.302.81a5.971 5.971 0 0 0-1.368-.79c-.08-.56-.443-2.388-.443-2.388h-3.778s-.358 1.827-.438 2.389a6.097 6.097 0 0 0-1.367.788c-.523-.21-2.303-.812-2.303-.812L4.127 9.634s1.421 1.224 1.867 1.57a4.698 4.698 0 0 0-.017 1.588c-.451.351-1.857 1.574-1.857 1.574l1.877 3.263s1.781-.597 2.307-.807c.42.322.88.588 1.368.789.08.562.444 2.387.444 2.387L13.89 20s.356-1.829.436-2.39c.49-.198.95-.464 1.368-.788.523.21 2.303.812 2.303.812l1.883-3.268s-1.407-1.224-1.852-1.574Z"
        vectorEffect="non-scaling-stroke"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.079 12.004c0 .263-.017.527-.05.788.444.35 1.851 1.574 1.851 1.574l-1.883 3.268s-1.78-.602-2.303-.812a5.79 5.79 0 0 1-1.368.789c-.08.56-.436 2.389-.436 2.389l-3.774-.002s-.364-1.825-.444-2.387a5.973 5.973 0 0 1-1.368-.789c-.526.21-2.307.807-2.307.807L4.12 14.365s1.406-1.222 1.857-1.573a4.698 4.698 0 0 1 .017-1.587c-.446-.347-1.867-1.571-1.867-1.571l1.878-3.269s1.78.602 2.303.812c.42-.32.88-.586 1.367-.788.08-.562.438-2.388.438-2.388L13.891 4s.363 1.827.443 2.389c.489.2.949.466 1.368.788.524-.21 2.301-.809 2.301-.809l1.874 3.274s-1.406 1.222-1.857 1.573c.041.26.06.525.059.789Zm-7.77 2.522a3.04 3.04 0 0 0 1.688.514 3.05 3.05 0 0 0 3.043-3.043 3.042 3.042 0 1 0-4.732 2.53Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="icon-gear-sharp-fill__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgIconGearSharpFill);
export default Memo;
